import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79bc7630"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "more-function" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " 更多功能 ", -1))
const _hoisted_3 = { class: "menu" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, " 价格测算 ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, " 下单教程 ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, " 运输须知 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_GuideMore = _resolveComponent("GuideMore")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "g-card menu-item",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navExpressRate && _ctx.navExpressRate(...args)))
      }, [
        _createVNode(_component_Icon, {
          class: "rate-icon icon",
          icon: "icon_calculation"
        }),
        _hoisted_4
      ]),
      _createElementVNode("div", {
        class: "g-card menu-item",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showTutorialModal && _ctx.showTutorialModal(...args)))
      }, [
        _createVNode(_component_Icon, {
          class: "guide-icon icon",
          icon: "icon_tutorials"
        }),
        _hoisted_5
      ]),
      _createElementVNode("div", {
        class: "g-card menu-item",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.navRule && _ctx.navRule(...args)))
      }, [
        _createVNode(_component_Icon, {
          class: "rule-icon icon",
          icon: "icon-explanation-main"
        }),
        _hoisted_6
      ])
    ]),
    _createVNode(_component_GuideMore, {
      visible: _ctx.isShowGuideMore,
      onClose: _ctx.closeGuideMore
    }, null, 8, ["visible", "onClose"])
  ]))
}